import { edmCampaign } from '@bingads-webui/edm-campaign';
import { isEmpty } from 'underscore';

export const loadAudiencesFactory = (cid, aid) => ({ searchFilter, top }) => {
  const payload = {
    top,
    count: true,
    audienceType: 'Remessaging,Product,Custom,CustomerList',
    deliverychannel: 'BingAds,AIM',
    filter: !isEmpty(searchFilter) ? { where: `contains(tolower(Name), '${searchFilter.toLocaleLowerCase().replace(/'/g, "''")}')` } : {},
  };

  return edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Audiences
    .get(payload)
    .toPromise()
    .then(({ value }) => value.map(audience => ({
      key: audience.Id,
      text: audience.Name,
      type: audience.Type,
    })));
};

export const loadAssociatedAudiencesFactory = (cid, aid) => () =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .NewCustomerAcquisitionGoals
    .get()
    .toPromise()
    .then(({ value }) => {
      if (value && value.length > 0 && value[0].Audiences) {
        return value[0].Audiences.map(audience => ({
          key: audience.Id,
          text: audience.Name,
        }));
      }
      return [];
    });

export const createOrUpdateNewCustomerAcquisitionGoal = ({ cid, aid }) => (payload) => {
  const edmEntityAccount = edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid);

  const createOrUpdateCall = payload && payload.NewCustomerAcquisitionGoals && payload.NewCustomerAcquisitionGoals.Id === -1
    ? edmEntityAccount.bulkCreate.bind(edmEntityAccount)
    : edmEntityAccount.bulkUpdate.bind(edmEntityAccount);

  return createOrUpdateCall(payload, {
    entityName: 'Model.NewCustomerAcquisitionGoal',
  });
};
